export enum PurchaseOrderType {
    PurchaseOrder = 1,
    PurchaseOrderUmbrella = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PurchaseOrderType.ts